<template>
  <div class="col-lg-6 mb-3">
    <div class=" card shadow-sm">
      <CardHeader :productSale="productSale"></CardHeader>
      <div class="card-body text-center p-0">
        <h1 style="font-size:350%">
          <span class="badge badge-primary"> {{ productSale.quantity }} </span>
        </h1>

        <h1 style="font-size:250%">
          <span
            class="badge text-wrap text-uppercase"
            v-bg-color="`#${productSale.color}`"
            >{{ productSale.product_name }}
          </span>
        </h1>
        <div
          class="alert alert-info"
          v-show="productSale.observation && productSale.observation.length > 0"
        >
          <i class="fas fa-comment"></i>
          {{ productSale.observation }}
        </div>
      </div>
      <div class="card-body text-center">
        <app-button-submit
          v-show="productSale.maked == 0"
          class="btn btn-secondary shadow-sm text-nowrap"
          @click="clickMakeHandler"
        >
          <!-- $emit('make', productSale.product_sale_id) -->

          <i class="fa fa-check"></i> REALIZADO
        </app-button-submit>

        <app-button-submit
          v-show="productSale.maked == 1"
          class="btn btn-danger mx-5 mb-3 shadow-sm"
          @click="clickUndoHandler"
        >
          <!-- $emit('undo', productSale.product_sale_id) -->
          <i class="fa fa-times"></i> DESHACER
        </app-button-submit>
      </div>
    </div>
  </div>
</template>
<script>
import { DinnerService } from "../DinnerService.js";
import { ticketLinkFactory } from "./ticketLinkFactory.js";
import CardHeader from "./CardHeader.vue";

const setBgColor = function(el, { value }) {
  el.style.backgroundColor = `${value}` || "green";
};

export default {
  components: {
    CardHeader
  },

  directives: {
    bgColor: {
      bind: setBgColor,
      update: setBgColor
    }
  },

  // filters

  props: {
    productSale: {
      default: () => ({
        id: 0,
        maked: 0,
        product_sale_id: 0,
        observation: ""
      })
    }
  },

  data: () => ({
    //
  }),

  computed: {
    ticketLink() {
      return ticketLinkFactory(this.productSale.sale_id);
    },
    hideId() {
      if (!this.productSale.sale_id) return "";
      var idInString = this.productSale.sale_id.toString();
      return idInString.slice(0, idInString.length - 3);
    },
    customId() {
      if (!this.productSale.sale_id) return "";
      var idInString = this.productSale.sale_id.toString();
      return idInString.slice(idInString.length - 3, idInString.length);
    }
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    clickMakeHandler() {
      DinnerService.savePreparedProduct({
        product_sale_id: this.productSale.product_sale_id
      }).then(() => {
        this.$emit("maked");
      });
    },
    clickUndoHandler() {
      DinnerService.savePreparedProduct({
        product_sale_id: this.productSale.product_sale_id,
        undo: 1
      }).then(() => {
        this.$emit("maked");
      });
    }
  }
};
</script>

<style scoped>
.custom_hover {
  color: white;
  background-color: black;
}

.d-info {
  display: flex;
  justify-content: flex-end;
}
</style>
